<script setup lang="ts">
import type { TooltipProviderProps } from 'reka-ui'
import { TooltipProvider } from 'reka-ui'

defineProps<TooltipProviderProps>()
</script>

<template>
  <TooltipProvider v-bind="$props">
    <slot />
  </TooltipProvider>
</template>
